module.exports = __webpack_public_path__ + "media/images/pro_subscription/partnership/v2/partenariat1@3x-3dc2225adb0ef5f22df556cb292b4d4c.jpg";